import { Button, Content, Modal } from 'react-bulma-components';

import React from 'react';

const Confirm = ({ 
  show, 
  title, 
  message, 
  onCancel, 
  onConfirm, 
  modal 
}) => {
  return (
    <Modal show={show} onClose={onCancel} {...modal}>
      <Modal.Card>
        <Modal.Card.Header showClose={false}>
          <Modal.Card.Title>{title}</Modal.Card.Title>
        </Modal.Card.Header>

        <Modal.Card.Body>
          <Content>
            <p>{message}</p>
          </Content>
        </Modal.Card.Body>

        <Modal.Card.Footer 
          style={{ justifyContent: 'flex-end', gap: '1rem' }}
        >
          <Button color="light" onClick={onCancel}>
            Cancel
          </Button>

          <Button color="primary" onClick={onConfirm}>
            OK
          </Button>
        </Modal.Card.Footer>
      </Modal.Card>
    </Modal>
  );
};

export default Confirm;
